import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderMobileViewer = ({ onClose }) => openPopupHelper({ popupName: popupNames.MOBILE_VIEWER, onClose });
